<template>
    <v-row>
        <v-col cols="12" class="text-h6 kbDarkBlue--text">
            <h3 class="pt-5">{{ from === 'Place' ? $t('general.placeSocialNetworks') : $t('general.eventSocialNetworks') }}</h3>
        </v-col>

        <v-col cols="12" v-for="(socialNetwork, index) in value" :key="socialNetwork.key">
            <v-card class="kbWhite">
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="4">
                            <v-select :items="socialNetworks"
                                      color="kbDarkBlue"
                                      :label="$t('general.socialNetworkSelect')"
                                      item-text="label"
                                      item-value="provider"
                                      v-model="socialNetwork.provider"
                                      :readonly="readonly">
                                <template slot="item" slot-scope="data">
                                    <v-list-item-avatar>
                                        <v-icon color="kbDarkBlue">{{data.item.icon}}</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title class="kbDarkBlue--text">{{data.item.label}}</v-list-item-title>
                                    </v-list-item-content>
                                </template>
                            </v-select>
                        </v-col>

                        <v-col cols="12" sm="8">
                            <v-text-field :label="$t('general.urlOrLink')"
                                          color="kbDarkBlue"
                                          v-model="socialNetwork.url"
                                          :rules="[rules.url]"
                                          :readonly="readonly">
                                <template slot="append-outer">
                                    <v-icon v-if="!readonly" color="red" @click="deleteItem(index)">clear</v-icon>
                                </template>
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>

        <v-col cols="12">
            <v-btn v-if="!readonly" color="kbGold" dark @click="addItem()" rounded>{{$t('general.socialNetworkAdd')}}</v-btn>
        </v-col>
    </v-row>
</template>

<script>
import socialNetworks from '@/libs/socialNetworks'
import { mapState } from 'vuex'
import uniqid from 'uniqid'
import rules from '@/libs/rules'
export default {
  computed: {
    ...mapState({
      methodNewEditPlace: state => state.events.methodNewEditPlace
    }),
    readonly () {
      return this.methodNewEditPlace === 'view'
    }
  },
  created () {
    if (this.value.length === 0) {
      this.addItem()
    }
  },
  data () {
    return {
      item: {
        provider: '',
        url: '',
        key: ''
      },
      socialNetworks: socialNetworks,
      rules
    }
  },
  methods: {
    addItem () {
      this.item.key = uniqid()
      this.value.push(JSON.parse(JSON.stringify(this.item)))
    },
    deleteItem (index) {
      this.value.splice(index, 1)
    }
  },
  props: ['value', 'from']
}
</script>
